import React from 'react';
import config from 'config';

const AppInfo = () => (
  <input id='api-url' type='hidden' value={config.serverURL} />
);

export default AppInfo;